export enum PlatformCookies {
    PHPSESSID = 'PHPSESSID',
    KB_SESSIONID = 'kb_session_id',
    KB_SESSIONID_TEST = 'kb_session_id_test',
}

// Common operation types
export enum OPERATIONS {
    PICKUP = 'pickup', // 'R'
    DELIVERY = 'delivery', // 'E'
    COLLECTION = 'collection', // 'C'
}

// Order states
export enum STATES {
    PREPARING = 'preparing',
    ASSIGNED = 'assigned',
    ROUTE_STARTED = 'route_started',
    ARRIVING = 'arriving',
    DELIVERED = 'delivered',
    FAILED = 'failed',
}

export enum ApplicationsEnum {
    SAAS = 'saas',
    FLASH = 'flash',
    STORK = 'stork',
    MERCHANTS = 'merchants',
    CO2 = 'co2',
    SPS = 'sps',
    MINDY = 'mindy',
    FLEETCARE = 'fleetcare',
    OMS = 'tms',
}

export enum Platform {
    FLASH = 'FLASH',
    SAAS = 'SAAS',
    STORK = 'STORK',
}

export enum DistanceUnit {
    Kilometer = 'km',
    Meter = 'mt',
    Mile = 'mi',
    Yard = 'yd',
}

export enum MassUnit {
    Gram = 'gr',
    Kilogram = 'kg',
    Ton = 'ton',
}

export enum SaasCloudDomains {
    prod = 'platform',
    test = 'testing',
}

export enum FlashDomains {
    prod = 'flash',
    test = 'flash-test',
}

export enum StorkDomains {
    prod = 'stork',
    test = 'stork-test',
}

export enum LegacyDeviceEventTypes {
    ENC = 'ENC',
    APAG = 'APAG',
    CALL = 'CALL',
    RFID = 'RFID',
    FZONA = 'FZONA',
    LZONA = 'LZONA',
    NL_ON = 'NL_ON',
    CEPI_C = 'CEPI_C',
    FUEDEP = 'FUEDEP',
    GPS_ON = 'GPS_ON',
    NL_OFF = 'NL_OFF',
    PANICO = 'PANICO',
    VISITA = 'VISITA',
    BAT_AUX = 'BAT_AUX',
    BAT_BAJ = 'BAT_BAJ',
    ENC_BAT = 'ENC_BAT',
    GPS_OFF = 'GPS_OFF',
    LOW_GPS = 'LOW_GPS',
    SIN_GPS = 'SIN_GPS',
    TMP_MAX = 'TMP_MAX',
    TMP_MIN = 'TMP_MIN',
    VEL_EXC = 'VEL_EXC',
    APAG_BAT = 'APAG_BAT',
    APE_CVAL = 'APE_CVAL',
    BOMBA_ON = 'BOMBA_ON',
    CEPI_C_D = 'CEPI_C_D',
    HOR_APAG = 'HOR_APAG',
    LOW_GPRS = 'LOW_GPRS',
    PARADA10 = 'PARADA10',
    APE_CIS_1 = 'APE_CIS_1',
    APE_CIS_2 = 'APE_CIS_2',
    APE_CIS_3 = 'APE_CIS_3',
    APE_CIS_4 = 'APE_CIS_4',
    APE_CIS_5 = 'APE_CIS_5',
    APE_CIS_6 = 'APE_CIS_6',
    APE_CIS_7 = 'APE_CIS_7',
    APE_PUE_T = 'APE_PUE_T',
    BOMBA_OFF = 'BOMBA_OFF',
    CAJA_UBIC = 'CAJA_UBIC',
    CE_SALIDA = 'CE_SALIDA',
    CIE_CIS_1 = 'CIE_CIS_1',
    CIE_CIS_2 = 'CIE_CIS_2',
    CIE_CIS_3 = 'CIE_CIS_3',
    CIE_CIS_4 = 'CIE_CIS_4',
    CIE_CIS_5 = 'CIE_CIS_5',
    CIE_CIS_6 = 'CIE_CIS_6',
    CIE_CIS_7 = 'CIE_CIS_7',
    CIE_PUE_T = 'CIE_PUE_T',
    CLSERVIDO = 'CLSERVIDO',
    HOR_PREND = 'HOR_PREND',
    REPOSIC_2 = 'REPOSIC_2',
    REPOSIC_3 = 'REPOSIC_3',
    REPOSIC_4 = 'REPOSIC_4',
    REPOSIC_5 = 'REPOSIC_5',
    REPOSIC_6 = 'REPOSIC_6',
    REPOSIC_7 = 'REPOSIC_7',
    SIN_ALIVE = 'SIN_ALIVE',
    SIRENA_ON = 'SIRENA_ON',
    TOBERA_ON = 'TOBERA_ON',
    APE_CIS_NA = 'APE_CIS_NA',
    CE_ENTREGA = 'CE_ENTREGA',
    CE_RECHAZO = 'CE_RECHAZO',
    DET_SIN_CL = 'DET_SIN_CL',
    MOTORAUX_0 = 'MOTORAUX_0',
    SIRENA_OFF = 'SIRENA_OFF',
    TOBERA_OFF = 'TOBERA_OFF',
    APE_PUE_CAB = 'APE_PUE_CAB',
    APE_PUE_HEL = 'APE_PUE_HEL',
    CAMBIO_DISP = 'CAMBIO_DISP',
    JAMMING_OFF = 'JAMMING_OFF',
    SENUELO_OFF = 'SENUELO_OFF',
    APE_PUE_T_NA = 'APE_PUE_T_NA',
    CERR_PUE_HEL = 'CERR_PUE_HEL',
    CIE_PUE_T_NA = 'CIE_PUE_T_NA',
    VEDA_NOCTURNA = 'VEDA_NOCTURNA',
}

export enum EXPORTS {
    CSV,
    XLSX,
}

export enum UserInviteStatusEnum {
    INVITED = 'invited',
    NOT_INVITED = 'not_invited',
    ACTIVE = 'active',
    EXPIRED = 'expired',
}

export enum TripPermissions {
    GetTrips = 'stork:trip.read',
    UpdateTrip = 'stork:trip.update',
    CreateTrip = 'stork:trip.create',
    DeleteTrip = 'stork:trip.delete',
}

export enum LocationPermissions {
    GetLocations = 'stork:location.read',
    UpdateLocation = 'stork:location.update',
    CreateLocation = 'stork:location.create',
    DeleteLocation = 'stork:location.delete',
}

export enum CarrierPermissions {
    GetCarriers = 'stork:carrier.read',
    UpdateCarrier = 'stork:carrier.update',
    CreateCarrier = 'stork:carrier.create',
    DeleteCarrier = 'stork:carrier.delete',
}

export enum AccountPermissions {
    GetAccounts = 'stork:account.read',
    UpdateAccount = 'stork:account.update',
    CreateAccount = 'stork:account.create',
    DeleteAccount = 'stork:account.delete',
}

export enum DriverPermissions {
    GetDrivers = 'stork:driver.read',
    UpdateDriver = 'stork:driver.update',
    CreateDriver = 'stork:driver.create',
    DeleteDriver = 'stork:driver.delete',
}

export enum TripDefinitionPermissions {
    GetTripDefinitions = 'stork:tripdefinition.read',
    UpdateTripDefinition = 'stork:tripdefinition.update',
    CreateTripDefinition = 'stork:tripdefinition.create',
    DeleteTripDefinition = 'stork:tripdefinition.delete',
}

export enum VehiclePermissions {
    GetVehicles = 'stork:vehicle.read',
    UpdateVehicle = 'stork:vehicle.update',
    CreateVehicle = 'stork:vehicle.create',
    DeleteVehicle = 'stork:vehicle.delete',
}

export enum SemitrailersPermissions {
    GetSemitrailers = 'stork:semitrailer.read',
    UpdateSemitrailer = 'stork:semitrailer.update',
    CreateSemitrailer = 'stork:semitrailer.create',
    DeleteSemitrailer = 'stork:semitrailer.delete',
}

export enum StateDefinitionPermissions {
    GetStateDefinitions = 'stork:statedefinition.read',
    UpdateStateDefinition = 'stork:statedefinition.update',
    CreateStateDefinition = 'stork:statedefinition.create',
    DeleteStateDefinition = 'stork:statedefinition.delete',
}

export enum TagPermissions {
    GetTags = 'stork:tag.read',
    UpdateTag = 'stork:tag.update',
    CreateTag = 'stork:tag.create',
    DeleteTag = 'stork:tag.delete',
}

export enum ServiceTypePermissions {
    GetServiceTypes = 'stork:servicetype.read',
    UpdateServiceType = 'stork:servicetype.update',
    CreateServiceType = 'stork:servicetype.create',
    DeleteServiceType = 'stork:servicetype.delete',
}

export enum ProductPermissions {
    GetProducts = 'stork:product.read',
    UpdateProduct = 'stork:product.update',
    CreateProduct = 'stork:product.create',
}

export enum ZonePermissions {
    GetZones = 'stork:zone.read',
    UpdateZone = 'stork:zone.update',
    CreateZone = 'stork:zone.create',
    DeleteZone = 'stork:zone.delete',
}

export enum OrdersPermissions {
    GetOrders = 'stork:order.read',
    UpdateOrder = 'stork:order.update',
    CreateOrder = 'stork:order.create',
    DeleteOrder = 'stork:order.delete',
}

export enum OrganizationKeyPermissions {
    GetOrganizationKeys = 'stork:organizationkey.read',
    CreateOrganizationKey = 'stork:organizationkey.create',
    UpdateOrganizationKey = 'stork:organizationkey.update',
    DeleteOrganizationKey = 'stork:organizationkey.delete',
}

// Special permission to trigger webhook
export enum WebhookPermissions {
    TRIGGER = 'stork:webhook.trigger',
}
// Special permission to use routing matrix
export enum RoutingMatrixPermissions {
    CREATE = 'stork:routingmatrix.create',
}

export enum EventsPermissions {
    COMMENT = 'stork:alerts.comment',
    RESOLVE = 'stork:alerts.resolve',
}
export enum AlertsPermissions {
    COMMENT = 'stork:events.comment',
    RESOLVE = 'stork:events.resolve',
}

export enum ConfigPermissions {
    UpdateEvents = 'stork:config_events.update',
    UpdateNotifications = 'stork:config_notifications.update',
}

export enum ChatParticipantPermissions {
    GetChatParticipants = 'stork:chatparticipant.read',
    CreateChatParticipant = 'stork:chatparticipant.create',
    UpdateChatParticipant = 'stork:chatparticipant.update',
    DeleteChatParticipant = 'stork:chatparticipant.delete',
}

export enum StorkAdminRoles {
    OrganizationAdmin = 'organization_admin',
    StorkAdmin = 'stork_admin',
}

export enum StandardUserRoles {
    DEFAULT = 'user_default_role',
    ADMIN = 'organization_admin',
}

export const ADMIN_ROLE_NAME = 'admin';

/**
 * Roles de OMS. Viven en la colección `roles` de users-api y viajan por nombre en el token,
 * que es de donde OMS deriva el nivel de acceso de cada usuario.
 *
 * Sólo `oms:admin` tiene permisos en el auth central (gestionar usuarios e invitaciones de
 * la organización); los otros tres existen para que OMS sepa qué puede hacer cada uno
 * dentro de la aplicación.
 */
export enum OmsRoles {
    ADMIN = 'oms:admin',
    MANAGER = 'oms:manager',
    OPERATOR = 'oms:operator',
    READONLY = 'oms:readonly',
}

export type StorkPermissions =
    | TripPermissions
    | LocationPermissions
    | CarrierPermissions
    | AccountPermissions
    | DriverPermissions
    | TripDefinitionPermissions
    | VehiclePermissions
    | SemitrailersPermissions
    | StateDefinitionPermissions
    | TagPermissions
    | ServiceTypePermissions
    | ProductPermissions
    | ZonePermissions
    | OrganizationKeyPermissions
    | WebhookPermissions
    | EventsPermissions
    | AlertsPermissions
    | ConfigPermissions
    | ChatParticipantPermissions
    | OrdersPermissions;

export enum PermissionsStatusEnum {
    TotalAccess = 'total_access',
    LimitedAccess = 'limited_access',
}

export enum ReportingTypeEnum {
    TRACKER = 'tracker',
    MOBILE_APP = 'mobileApp',
}

export enum OrdersEventsEnum {
    PLANNED = 'planned',
    ROUTE_STARTED = 'route_started',
    ARRIVING = 'arriving',
    DELIVERED = 'delivered',
    FAIL = 'fail',
}

export enum TripsEventsEnum {
    PLANNED = 'planned',
    MODIFIED = 'modified',
}

export enum ModuleEnum {
    VEHICLES = 'vehicles',
    DRIVERS = 'drivers',
    CARRIERS = 'carriers',
    ACCOUNTS = 'accounts',
    LOCATIONS = 'locations',
    ZONES = 'zones',
    EVENTS = 'events',
    TRIPS = 'trips',
    SEMITRAILERS = 'semitrailers',
}

export enum ModuleViewEnum {
    VEHICLES = 'vehicles',
    SEMIS = 'semis',
    DRIVERS = 'drivers',
    CARRIERS = 'carriers',
    LOCATIONS = 'locations',
    ZONES = 'zones',
    ALERTS_EVENTS = 'alerts_events',
    CONFIGURATIONS = 'configurations',
}

export const MINDY_ROLES = ['mindy:admin', 'mindy:manager', 'mindy:consultant', 'mindy:operational', 'mindy:guest'];
